/**
 * Maintained by Sandon.
 */
<template>
  <div
    class="sy-cascade-selector"
    :class="{'sy-cascade-selector--ie9': isIE9}"
    :style="{height: fixHeight ? `${height}px` : ''}"
    v-click-outside="{outside: _hideDropdown, inside: _showDropdown}">
    <!--为了兼容IE9，width不能为auto -->
    <magic-input
      ref="magicInput"
      :multiple="multiple"
      :disabled="disabled"
      :filterable="filterable"
      :fixHeight="fixHeight"
      :visible="visible"
      :selectedTagsMaxHeight="selectedTagsMaxHeight"
      :popperWidth="showFilter ? filterPopoverWidth : popoverWidth"
      :filterPlaceholder="filterPlaceholder"
      :placeholder="placeholder"
      :text="firstNodeText"
      :completeText="firstNodeCompleteText"
      :size="size"
      :popperClass="`sy-cascade-selector__popover ${isIE9 ? 'sy-cascade-selector__popover--ie9' : ''} ${popperClass}`"
      :disableTitle="disableTitle"
      @toggle="_toggleVisible"
      @clear="_singleClear"
      @filter="filter = $event">
      <!--多选的选中-->
      <el-tooltip
        v-for="node in showedSelectedNodes"
        :key="_getKey(node)"
        effect="light"
        :content="_getShowText(node, true)"
        placement="top"
        open-delay="700">
        <el-tag
          :closable="!disabled"
          @close="_del(node)"
          type="info"
          :size="size"
          disable-transitions>
          {{_getShowText(node)}}
        </el-tag>
      </el-tooltip>
      <template slot="popper">
        <!--搜索候选列表-->
        <div
          v-if="showFilter"
          class="sy-cascade-selector__filter-list-wrap"
          :style="{maxHeight: `${popperHeight}px`}">
          <filter-list
            :filterKw="filter"
            :remote-filter="remoteFilter"
            :items="filterCandidates"
            :isSelected="_isSelected"
            :width="filterPopoverWidth"
            @item-click="_clickFilterItem">
          </filter-list>
        </div>
        <!--级联-->
        <cascader
          :layer-height="popperHeight"
          :defaultLoadFirst="false"
          :label-divider="labelDivider !== '/' ? labelDivider : showDivider"
          :visible="visible"
          v-show="!showFilter"
          ref="cascade"
          v-bind="$props"
          :selected-keys="selectedKeys"
          @silent-change="_change($event, true)"
          @change="_change($event, false)"
          @check-change="_checkChange"
          @checkbox-click="_checkboxClick"
          @tree-initialized="_treeInitialized"
          @width-change="_cascadeWidthChange">
        </cascader>
      </template>
    </magic-input>
  </div>
</template>

<script>
  import i18n from './i18n'
  import clickOutside from '../../../utils/click-outside'
  import Cascader from '../cascader'
  import {defaultProps} from '../cascader/Node'
  import {genMap} from '../cascader/utils'
  import FilterList from '../filter-list'
  import MagicInput from '../magic-input'
  import {keyBy} from 'lodash-es'
  const pageText = window.fe.getPageText(i18n)

  export default {
    name: 'cascade-selector',
    components: {Cascader, FilterList, MagicInput},
    props: {
      // 是否多选
      multiple: {type: Boolean, default: false},
      // 是否只有叶子节点可选
      mustLeaf: {type: Boolean, default: false},
      // 树的数据，传了这个值则认为是全量数据，而不是懒加载，会忽略`lazy`和`load`属性
      data: Array,
      // 是否懒加载数据
      lazy: {type: Boolean, default: false},
      // 懒加载数据时的加载函数
      load: {type: Function},
      /*
        {
          key: 'id', // 指定代表唯一值的属性的`key`值
          label: 'label', // 指定代表展示文案的属性的`key`值
          children: 'children', // 指定代表子节点的属性的`key`值
          disabled: 'disabled', // 指定代表节点是否禁用的属性的`key`值
          isLeaf: 'isLeaf' // 指定代表节点是否是叶子节点的属性的`key`值
        }
      */
      props: Object,
      placeholder: {type: String, default: pageText.pleaseChoose},
      // 是否固定高度，非固定高度时，高度会被选中的内容撑开，固定高度时则不会，而是通过hover展示全部，非hover则会隐藏；
      fixHeight: {type: Boolean, default: false},
      // 选中项文本是否显示完整路径
      showComplete: {type: Boolean, default: false},
      // 选中条目展示分隔符，表示串起来的各节点的label的分隔字符，
      // 会影响 Node.completeLabel 值，也会在 'showComplete' 为true时影响选中项展示的文案
      labelDivider:{type: String, default: '/'},
      showDivider: {type: String, default: '/'}, // todo 废弃
      // 下拉级联展示框的高度
      popperHeight: {type: Number, default: 300},
      // 选中条目的key，能够使用sync，注意如果使用sync，返回的ids是会被精简化的（一个子树都被选中，只会返回子树的根节点）
      selectedKeys: {type: Array, default: () => []},
      // 需要配合selectedIds使用，并且两者一一对应；
      // 用于有初始数据+懒加载的场景，因为懒加载时有些初始的数据没法获取其label，`selectedData`用来指定每个id对应的label;
      // [{key: '', label: ''}]， 数组元素的键值是根据`props`来的；
      selectedData: {type: Array, default: () => []},
      // 过滤节点是否展示的函数，此函数的参数是节点的Node数据，返回true表示展示，false表示不展示；
      showNodeFilter: Function,
      // 是否可进行搜索，如果需要远程搜索，配合`remoteFilter`使用，如果不设置`remoteFilter`，则会走默认本地搜索逻辑；
      filterable: {type: Boolean, default: false},
      // 远程搜索的自定义逻辑，懒加载时建议走远程搜索逻辑，异步获取数据时，此函数应为async函数或返回一个promise的函数；
      // 此函数的参数是搜索词，返回值数据格式为：
      // [{
      //   key: '',
      //   label: '',
      //   completeLabel: ''
      // }]
      remoteFilter: Function,
      // 过滤搜索时，输入框的placeholder
      filterPlaceholder: {type: String, default: pageText.search},
      // 级联展开时，每个层级的宽度
      layerWidth: {type: Number, default: 240},
      // 禁用, 不让用户进行操作
      disabled: {type: Boolean, default: false},
      // 选中项展示时，最大的高度，超长会显示滚动条
      selectedTagsMaxHeight: {type: Number, default: 100},
      // size大小
      size: {type: String, default: 'small'},
      // 不需要title
      disableTitle: {type: Boolean, default: false},
      // 自动展开
      expandPath: {type: Array, default: () => []},
      // popperClass为浮层对应的类名
      popperClass: {type: String, default: ''}
    },
    directives: {
      'click-outside': clickOutside
    },
    data () {
      return {
        height: 32,
        isIE9: navigator.userAgent.indexOf('MSIE 9') !== -1,
        // isWin: navigator.userAgent.toLowerCase().indexOf('windows') !== -1,
        // isIE10: navigator.userAgent.indexOf('MSIE 10') !== -1,
        popoverWidth: this.layerWidth, // 级联选择时popover宽度
        filterPopoverWidth: 360, // 过滤时的popover宽度
        filter: '', // 搜索词
        filterItems: [
          // {
          //   key: '',
          //   label: '',
          //   completeLabel: ''
          // }
        ],
        filterCandidates: [], // Node 的数组
        visible: false, // 下拉展示状态
        isInputFocus: false, // 是否输入框被focus
        isFirstShowCascade: true, // 懒加载 + 第一次展现下拉时，加载第一级数据

        selectedNodes: {
          completeNodes: [],
          simpleNodes: [],
          complete: [],
          simple: [],
          // unInitSelectedIds: [], // todo remove when ready
          unInitSelectedKeys: [],
          selectedData: []
        }, // 选中的节点信息
        showedSelectedNodes: [] // 选中的节点被过滤后展示的节点
      }
    },
    computed: {
      // 选中的第一个节点展示的文字
      firstNodeText: function () {
        return (this.showedSelectedNodes.length && this._getShowText(this.showedSelectedNodes[0])) || ''
      },
      firstNodeCompleteText: function () {
        return (this.showedSelectedNodes.length && this._getShowText(this.showedSelectedNodes[0], true)) || ''
      },
      showFilter: function () {
        return this.filterable && this.filter.length
      }
    },
    watch: {
      showFilter () {
        const self = this
        this.$nextTick(function () {
          self.updatePopover()
        })
      },
      filter () {
        this.$emit('filter', this.filter)
      }
    },
    created () {
      if (this.size === 'mini') {
        this.height = 28
      }
    },
    mounted () {
      // this.resetInputHeight(true)
      if (this.$refs['magicInput']) {
        this.filterPopoverWidth = Math.max(this.filterPopoverWidth,
          this.$refs['magicInput'].$el.getBoundingClientRect().width)
      }
    },
    beforeDestroy () {
    },
    methods: {
      // 根据selectedData获取展示节点
      _getUninitShowedNodes (ids) {
        if (!ids || !ids.length || !this.selectedData) return []

        const unInitShowedNodes = new Set()
        const keyPropName = this.props['key'] || defaultProps['key']
        const selectedDataMap = genMap(this.selectedData, keyPropName)
        ids.forEach((id) => {
          if (selectedDataMap[id]) {
            unInitShowedNodes.add(selectedDataMap[id])
          }
        })
        return [...unInitShowedNodes]
      },
      // 选中的数据集发生变化
      _change (selectedNodes, silent = false) {
        // console.log('change事件', selectedNodes, silent)
        // 保存选中数据
        this.selectedNodes = selectedNodes
        // 更新高度
        // this.resetInputHeight()
        this.$refs['magicInput'] && this.$refs['magicInput'].updateHeight()

        // 单选 + 手动点选时，收起下拉
        if (!this.multiple && !silent) {
          this.$nextTick(() => {
            this._hideDropdown()
          })
        }

        // 构建showedSelectedNodes
        let candidateShowNodes = this._getUninitShowedNodes(selectedNodes.unInitSelectedKeys)
        candidateShowNodes = candidateShowNodes.concat(selectedNodes.simpleNodes)
        this.showedSelectedNodes = this._filterShowNodes(candidateShowNodes)

        // selectedNodes.selectedData = this.selectedData
        // selectedData 所有选中项的 data 数组
        const keyPropName = this.props['key'] || defaultProps['key']
        const selectedDataMap = keyBy(this.selectedData, keyPropName)
        selectedNodes.selectedData = selectedNodes.unInitSelectedKeys.map(_ => selectedDataMap[_])
          .concat(selectedNodes.simple)

        // 发送事件
        if (!silent) {
          let selectedIds = this.selectedNodes.simpleNodes.map(node => node.key)
          selectedIds = selectedIds.concat(this.selectedNodes.unInitSelectedKeys)

          this.$emit('update:selectedKeys', selectedIds)
          this.$emit('change', selectedNodes)
        }
      },
      // 过滤展示的节点
      _filterShowNodes (candidateShowNodes) {
        return this.showNodeFilter
          ? candidateShowNodes.filter((node) => this.showNodeFilter(node, candidateShowNodes))
          : candidateShowNodes
      },
      // 透传 check-change 事件
      _checkChange (node) {
        this.$emit('check-change', node)
      },
      // 透传 checkbox-click 事件
      _checkboxClick (node) {
        this.$emit('checkbox-click', node)
      },
      // 节点的展示
      _getShowText (treeNode, forceComplete = false) {
        if (!treeNode) return ''

        if (treeNode._isTreeNode) {
          let text = [treeNode.label]
          if (this.showComplete || forceComplete) {
            let node = treeNode.parent
            while (node && node.parent) {
              text.push(node.label)
              node = node.parent
            }
          }
          return text.reverse().join(this.labelDivider !== '/' ? this.labelDivider : this.showDivider)
        } else {
          const labelKey = this.props['label'] || defaultProps['label']
          const completeLabelKey = this.props['completeLabel'] || defaultProps['completeLabel']
          if (this.showComplete || forceComplete) {
            return treeNode[completeLabelKey] || treeNode[labelKey] || ''
          }
          return treeNode[labelKey] || ''
        }
      },
      // 单选时，清空输入框
      _singleClear () {
        if (this.selectedNodes.simpleNodes.length) {
          this._del(this.selectedNodes.simpleNodes[0])
        } else {
          this._del(this._getUninitShowedNodes(this.selectedNodes.unInitSelectedKeys))
        }
      },
      // 删除一个选中的值
      _del (node) {
        this.$refs['cascade'].unselectNodes([node])
        this.$emit('unselect-node-tag', node)
      },
      // 级联选择器的宽度变化
      async _cascadeWidthChange (width) {
        this.popoverWidth = width
        await this.$nextTick()
        this.updatePopover()
      },
      // 展示dropdown
      _showDropdown () {
        // console.log('show')
        // 懒加载 + 第一次展现下拉时，加载第一级数据
        if (this.lazy && this.load && this.$refs['cascade'] && this.isFirstShowCascade) {
          this.isFirstShowCascade = false
          this.$refs['cascade'].firstLoad()
        }
        if (this.visible) return
        if (this.disabled) return
        this.visible = true
      },
      // 隐藏dropdown
      _hideDropdown () {
        // console.log('hide')
        if (!this.visible) return
        this.visible = false
        // this.filter = ''
        this.$refs['magicInput'] && this.$refs['magicInput'].clearFilter()
      },
      // toggle dropdown的显示/隐藏
      _toggleVisible (e) {
        // console.log('toggle')
        if (this.visible) {
          this._hideDropdown()
          // 阻止由于clickoutside导致的展开
          e.stopPropagation()
        } else {
          this._showDropdown()
        }
      },
      // for key
      _getKey (node) {
        return node._isTreeNode ? node.key : node[this.props['key'] || defaultProps['key']]
      },
      // 提供全量数据时，在tree被初始化之后
      _treeInitialized (root) {
        // 初始化filterItems
        if (!this.remoteFilter) {
          this._initFilterCandidates(root)
        }
      },
      // 初始化 filterCandidates
      _initFilterCandidates (root) {
        const targetNodes = []
        let arr = [root]
        for (let i = 0; i !== arr.length; i++) {
          arr = arr.concat(arr[i].childNodes)

          if (!arr[i].parent) continue // root
          if (this.mustLeaf) {
            arr[i].isLeaf && targetNodes.push(arr[i])
          } else {
            !arr[i].singleAndNotMustLeaf && targetNodes.push(arr[i])
          }
        }
        // 目标节点取决于是否必须是叶子节点
        this.filterCandidates = targetNodes
      },
      // 搜索筛选项被点击
      _clickFilterItem (item) {
        const isSelected = this._isSelected(item.key)
        isSelected ? this._unselectFilterItem(item) : this._selectFilterItem(item)
      },
      // 取消选中搜索筛选项
      _unselectFilterItem (item) {
        // todo remove
        if (this.remoteFilter) {
          // const index = this.selectedIds.findIndex(id => id === item.key)
          // index !== -1 && this.selectedIds.splice(index, 1)
        } else {
          // 本地搜索, 直接调用cascade的unselectKeys接口
        }
        this.$refs['cascade'].unselectKeys([item.key], false)
      },
      // 选中了搜索筛选项
      _selectFilterItem (item) {
        if (this.remoteFilter) {
          // 需要修改selectedIds，也需要修改selectedData
          const keyPropName = this.props['key'] || defaultProps['key']
          const labelPropName = this.props['label'] || defaultProps['label']
          const completeLabelKey = this.props['completeLabel'] || defaultProps['completeLabel']
          let exist = this.selectedData.find(data => data[keyPropName] === item.key)
          if (!exist) {
            this.selectedData.push({
              [keyPropName]: item.key,
              [labelPropName]: item.label,
              [completeLabelKey]: item.completeLabel,
              _raw: item
            })
          } else {
            exist[completeLabelKey] = item.completeLabel
            exist._raw = item
          }
        }

        this.$refs['cascade'].selectKeys([item.key], false)
      },
      // 判断条目是否选中
      _isSelected (key) {
        if (this.selectedNodes.completeNodes.findIndex(node => node.key === key) !== -1) {
          return true
        } else {
          return this.selectedNodes.unInitSelectedKeys.findIndex(id => id === key) !== -1
        }
      },
      // 外部接口 - popover 更新，也被内部使用
      updatePopover () {
        this.$refs['magicInput'] && this.$refs['magicInput'].updatePopper()
      }
    }
  }
</script>

<style scoped lang="scss">
  .sy-cascade-selector {
    display: inline-block;
    line-height: 0;
    width: 100%;
  }
  .sy-cascade-selector__filter-list-wrap{
    overflow-y: auto;
  }
</style>
<style>
  /*因为popper会被抽取到body下，所以得全局样式*/
  .sy-cascade-selector__popover .sy-tree-cascade {
    box-shadow: none;
  }
  .sy-cascade-selector__popover.sy-cascade-selector__popover--ie9 .sy-tree-cascade__layer{
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }
  .sy-cascade-selector__popover{
    padding: 0;
  }
</style>
